<template>
  <div class="informationMain" v-if="companyApplicantVisible_">
    <div class="informationBg" @click="onkonw"></div>
    <div class="companyApplicant">
      <div class="informationLef"></div>
      <div class="informationRig">
        <h4>企业账号申请</h4>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="0px" class="ruleForm">
          <p style="float:left">姓名</p>
          <el-form-item label prop="loginName">
            <el-input type="text" v-model="ruleForm.loginName" placeholder="输入姓名">
            </el-input>
          </el-form-item>
          <p style="float:left">企业名称</p>
          <el-form-item label prop="company">
            <el-input v-model="ruleForm.company" type="text" placeholder="请输入企业名称名称">
            </el-input>
          </el-form-item>
          <p style="float:left">手机号/邮箱</p>
          <el-form-item label prop="loginPhone">
            <el-input v-model="ruleForm.loginPhone" type="tel" placeholder="请输入手机号">
            </el-input>
          </el-form-item>
          <p style="text-align: left;">验证码</p>
          <el-form-item label prop="numCode" class="verification">
            <el-col :span="13">
              <el-input v-model="ruleForm.numCode" autocomplete="off"></el-input>
            </el-col>
            <el-col class="line" :span="1">&nbsp;</el-col>
            <el-col :span="10">
              <button class="btn" @click="getVerificationCode('ruleForm')" :disabled="disabled">{{verificationCode}}
                <span v-if="ver">秒后重试</span>
              </button>
            </el-col>
          </el-form-item>
          <el-button class="btn_login" type="primary" @click="submitForm('ruleForm')">提交申请</el-button>
          <div class="go_back">我们将在2个工作日内与您联系</div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
export default {
  name: "companyApplicant",
  props: {
    companyApplicantVisible: {
      type: [Boolean],
    },
  },
  data() {
    let checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("验证码不能为空"));
      }
    };
    let nameRules = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("姓名不能为空"));
      }
    };
    let username = (rule, value, callback) => {
      let reg = /^1\d{10}$/;
      let email = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!value) {
        return callback(new Error("手机号/邮箱不能为空"));
      }
      if (value.indexOf("@") === -1) {
        if (!reg.test(value)) {
          return callback(new Error("手机号不正确"));
        }
      } else {
        if (!email.test(value)) {
          return callback(new Error("邮箱不正确"));
        }
      }
      callback();
    };
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码长度不能小于6个字符"));
      } else if (value.length > 16) {
        callback(new Error("密码长度不能超过16个字符"));
      }
      callback();
    };
    let invitationCode_rule = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入企业邀请码"));
      }
      callback();
    };
    let company_rule = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入公司名称"));
      }
      callback();
    };
    return {
      //   companyApplicantVisible_: this.companyApplicantVisible,
      ruleForm: {
        loginPhone: "",
        loginName: "",
        company: "",// 企业名称
        numCode: ""// yan zheng ma
      },
      rules: {
        loginPhone: [{ required: true, validator: username, trigger: "blur" }],
        // password: [{ validator: validatePass, trigger: "blur" }],
        loginName: [{ validator: nameRules, trigger: "blur" }],
        // invitationCode: [{ validator: invitationCode_rule, trigger: "blur" }],
        company: [{ validator: company_rule, trigger: "blur" }],
        numCode: [{ validator: checkAge, trigger: "blur" }],
      },
      verificationCode: "获取验证码",
      disabled: false,
      ver: false,
    };
  },
  computed: {
    companyApplicantVisible_() {
      return this.companyApplicantVisible
    }
  },
  methods: {
    // 登录
    async submitForm(formName) {
      var that = this;
      let verify = true
      this.$refs.ruleForm.validateField(["loginPhone", "numCode", "loginName", "company"], errTip => {
        if (errTip) {
          // 会调用多次    numCode: '',

          verify = false;
          return
        }
      });
      if (verify) {
        let params = {
          applyType: 2,//
          companyName: this.ruleForm.company,//
          loginPhone: this.ruleForm.loginPhone,//
          name: this.ruleForm.loginName,//
          userId: undefined,//
          verificationCode: this.ruleForm.numCode//
        }
        const res = await this.catReq1Service("/user/add_user_apply_record", params)
        if (res.resultCode === "1") {
          this.$emit("setCompanyInformationVisible", false)
        }
      }

    },
    // 获取验证码
    getVerificationCode() {
      var verify = true;
      this.$refs.ruleForm.validateField(["loginPhone"], errTip => {
        if (errTip) {
          // 会调用多次
          verify = false;
        }
      });
      if (verify) {
        this.ver = true // 显示span
        let timeCounter;
        this.disabled = true;
        this.verificationCode = 60;
        if (this.verificationCode < 0) {
          clearTimeout(timeCounter);
          this.disabled = false;
          this.ver = false
          this.verificationCode = "获取验证码";
        }
        timeCounter = setInterval(() => {
          this.verificationCode--;

          if (this.verificationCode < 0) {
            clearTimeout(timeCounter);
            this.disabled = false;
            this.ver = false
            this.verificationCode = "重新获取验证码";

          }
        }, 1000);
        if (this.ruleForm.loginPhone.indexOf("@") === -1) {
          let params = {
            loginPhone: this.ruleForm.loginPhone
          }

          this.catReq1Service("/user/send_verifyCode", params).then(response => {
            if (!response.success) {
              this.disabled = false;
              this.verificationCode = 0
              this.verificationCode = "获取验证码";
              clearTimeout(timeCounter);
              this.ver = false
              return;
            }
            // callback && callback(this.scopedForm);
          })
            .catch(error => {
            });
        } else {
          let params = {
            email: this.ruleForm.loginPhone,
            platformType: 1,
          }
          this.catReq1Service("/user/send_email_code", params).then(response => {
            if (!response.success) {
              this.disabled = false;
              this.verificationCode = 0
              this.verificationCode = "获取验证码";
              clearTimeout(timeCounter);
              this.ver = false
              return;
            }
            // callback && callback(this.scopedForm);
          })
            .catch(error => {

            });
        }

      }

    },
    onkonw() {
      this.$emit("setCompanyInformationVisible", false)
    },
    // submitForm() {
    //   this.companyApplicantVisible_ = false
    // }
  },
};
</script>

<style lang="less" scoped>
.informationMain {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 999;
}
.informationBg {
  position: fixed;
  background: rgba(29, 29, 29, 1);
  opacity: 0.43;
  height: 100%;
  width: 100%;
  z-index: 999;
}
.companyApplicant {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 850px;
  height: 550px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 20px 0px rgba(56, 56, 56, 0.2);
  border-radius: 10px;
  z-index: 1000;
  .informationLef {
    float: left;
    height: 100%;
    width: 50%;
    border-bottom-left-radius: 10px;
    border-top-left-radius: 10px;
    // background: url("../assets/imgs/companyApplicant/Applicant.png") center
    //   no-repeat;
  }
  .informationRig {
    float: right;
    height: 100%;
    width: 50%;
    h4 {
      margin-top: 40px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(26, 105, 179, 1);
    }
    .ruleForm {
      text-align: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      width: 66%;
      margin: 0 auto;
      p {
        margin-bottom: 5px;
      }
      /deep/.el-input__inner {
        height: 36px;
        line-height: 36px;
        border: 1px solid rgba(192, 192, 192, 1);
        border-radius: 2px;
      }
      button {
        width: 100%;
        height: 40px;

        border-radius: 2px;
        line-height: 0px;
      }
      .register {
        color: rgba(69, 69, 69, 1);
        margin-top: 10px;
        text-align: right;
        cursor: pointer;
      }
      .el-form-item {
        margin-bottom: 20px;
      }
      .verification {
        button {
          width: 100%;
          height: 36px;
          background: #10a4fe;
          //border: 1px solid #454545;
          border-radius: 2px;
          color: white;
        }
        button:hover {
          // background: #f1f1f1;
          // border: 1px solid #454545;
          //color: #454545;
        }
        button:active {
          // background: #454545;
          color: #ffffff;
        }
      }

      .btn_login {
          margin-top: 5px;
        background: #0c76da;
        border-radius: 2px;
        border: 0px;
      }
      .go_back {
        margin-top: 11px;
        text-align: left;
      }
    }
  }
}
</style>